<div class="page-title-area reseller-hosting-title">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Almacenamiento en la Nube</h2>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Inicio</a></li>
                        <li>Servicios</li>
                        <li>Almacenamiento en la Nube</li>
                    </ul>
                </div>
            </div>

            <div class="special-intro-offer-wrap">
                <div class="row">
                    <h4 style="color: #FFF;">Principales Usos</h4>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-folder"></i>
                            <h3>Respaldo y recuperación de datos</h3>
                            <p>Protege la información crítica de tu empresa con copias de seguridad automatizadas y
                                almacenamiento redundante.</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-rocket"></i>
                            <h3>Alojamiento y distribución de contenido</h3>
                            <p>Almacena y entrega contenido multimedia, documentos y aplicaciones de forma rápida y
                                segura.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-magnifying-glass-chart"></i>
                            <h3>Análisis de datos (Big Data)</h3>
                            <p>Aprovecha la escalabilidad del almacenamiento en la nube para gestionar grandes volúmenes
                                de información.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-book-atlas"></i>
                            <h3>Investigación y desarrollo</h3>
                            <p>Soluciones para universidades, centros de investigación y empresas que necesitan procesar
                                gran volumen de datos.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-photo-film"></i>
                            <h3>Almacenamiento multimedia</h3>
                            <p>Guarda fotos, videos, modelos 3D y archivos gráficos sin preocuparte por la capacidad de
                                almacenamiento.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<section class="customer-support-area pt-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="customer-title">
                    <h2 class="text-center">¿Qué es el Almacenamiento en la Nube?</h2>
                    <p class="text-justify">El almacenamiento en la nube es un servicio que permite guardar, gestionar y
                        acceder a datos y archivos a través de internet, sin depender de dispositivos físicos como
                        discos duros o servidores locales. En lugar de almacenar la información en una computadora
                        personal o en una red privada, los datos se alojan en centros de datos seguros y escalables,
                        permitiendo su acceso desde cualquier lugar y en cualquier momento.</p>

                </div>


            </div>


        </div>
    </div>
</section>

<section class="customer-support-area pt-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="customer-title">
                    <h2 class="text-center">Seguridad, Escalabilidad y Rendimiento para tu Información</h2>

                    <p class="text-justify">En enCloud, ofrecemos un servicio de almacenamiento en la nube diseñado para
                        empresas, startups, desarrolladores, investigadores y profesionales que buscan una solución
                        confiable, escalable y segura para almacenar, gestionar y proteger sus datos.

                    </p>
                    <p class="text-justify">Nuestra infraestructura permite manejar desde archivos individuales hasta
                        volúmenes masivos de información, garantizando un acceso rápido y seguro en cualquier momento y
                        desde cualquier lugar.
                    </p>
                </div>

                <ul class="custom-list">
                    <p><strong>Beneficios de almacenamiento en la nube con nosotros:</strong></p>
                    <li><strong>Escalabilidad sin límites -</strong> Desde gigabytes hasta petabytes.</li>
                    <li><strong>Máxima seguridad y cifrado -</strong> Cifrado AES-256 en reposo y TLS en tránsito.</li>
                    <li><strong>Alta disponibilidad y redundancia –</strong> Garantizamos acceso constante a tus datos.</li>
                    <li><strong>Costos competitivos -</strong> Pagos accesibles y sin sorpresas.</li>
                    <li><strong>Acceso rápido y baja latencia –</strong> Centros de datos en México para mayor velocidad.</li>
                </ul>
            </div>


        </div>
    </div>
</section>

<section class="customer-support-area pt-70">

    <div class="container">
        <h1 class="text-center">Tipos de Almacenamiento en la Nube que Ofrecemos</h1>

        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="frequently-content-wrap">
                    <ul>
                        <li>
                            <i class="fa-solid fa-object-ungroup"></i>
                            <h3>Almacenamiento de Objetos (Object Storage)</h3>
                            <p>Ideal para aplicaciones web, backups, repositorios de datos y contenido multimedia.
                                Compatible con <span class="highlight">API S3</span>, permitiendo una integración sin
                                esfuerzo con aplicaciones y servicios existentes.
                            <p>
                            <p class="example"> <strong>Ejemplo de uso:</strong> Plataformas de video usan
                                almacenamiento de objetos para
                                gestionar millones de archivos de video y servir contenido a usuarios.</p>

                        </li>
                        <li>
                            <i class="fa-solid fa-cube"></i>
                            <h3>Almacenamiento en Bloques (Block Storage)</h3>
                            <p>Diseñado para bases de datos, máquinas virtuales y aplicaciones empresariales que
                                requieren acceso de baja latencia y alto rendimiento. Compatible con protocolos como
                                <span class="highlight">iSCSI</span>.
                            <p>
                            <p class="example"><strong>Ejemplo de uso:</strong> Empresas de comercio electrónico usan
                                almacenamiento en
                                bloques para manejar millones de transacciones por segundo.</p>

                        </li>
                        <li>
                            <i class="fa-solid fa-file-fragment"></i>
                            <h3>Almacenamiento de Archivos (File Storage)</h3>
                            <p>Solución optimizada para compartir archivos dentro de redes empresariales. Compatible con
                                <span class="highlight">NFS, SMB y FTP</span>, facilitando el trabajo colaborativo y el
                                acceso remoto a datos.
                            <p>
                            <p class="example"><strong>Ejemplo de uso:</strong> Empresas de arquitectura y diseño usan
                                almacenamiento de
                                archivos para compartir modelos 3D y planos CAD con sus equipos en tiempo real.</p>

                        </li>
                        <li>
                            <i class="fa-solid fa-snowflake"></i>
                            <h3>Almacenamiento de Archivos Fríos (Cold Storage)</h3>
                            <p>Perfecto para información que no necesita acceso frecuente, como archivos de auditoría,
                                registros históricos o copias de seguridad a largo plazo.
                            <p>
                            <p class="example"><strong>Ejemplo de uso:</strong> Bancos y aseguradoras almacenan millones
                                de documentos en
                                almacenamiento en frío para cumplir con requisitos legales de conservación de datos por
                                varios años.</p>

                        </li>
                    </ul>
                </div>
            </div>
        </div>


    </div>
</section>


<section class="domain-pricing-list-area pt-70">
    <div class="container">
        <div class="row">


            <div class="col-lg-12 col-md-12">
                <h2 style="margin-bottom: 40px;
                text-align: center;
                font-size: 35px;">📦 Planes de Almacenamiento en la Nube</h2>

                <h3 style="text-align: center;">Almacenamiento de Objetos (Object Storage)</h3>
                <div class="custom-table">
                    <table class="table">
                        <thead>
                            <tr>

                                <th scope="col">Plan</th>
                                <th scope="col">Espacio</th>
                                <th scope="col">Seguridad</th>
                                <th scope="col">Integraciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td scope="row">
                                    Básico
                                </td>

                                <td class="special">
                                    1 TB
                                </td>
                                <td class="special">
                                    Cifrado estándar
                                </td>
                                <td class="special">
                                    API S3
                                </td>

                            </tr>
                            <tr>


                                <td scope="row">
                                    Profesional
                                </td>

                                <td class="special">
                                    5 TB
                                </td>
                                <td class="special">
                                    Cifrado avanzado
                                </td>
                                <td class="special">
                                    API S3
                                </td>


                            </tr>
                            <tr>

                                <td scope="row">
                                    Empresarial
                                </td>

                                <td class="special">
                                    10 TB
                                </td>
                                <td class="special">
                                    Cifrado avanzado
                                </td>
                                <td class="special">
                                    API S3
                                </td>



                            </tr>
                            <tr colspan="3">

                                <td colspan="5" scope="row">
                                    Plan Personalizado (Contáctanos)
                                </td>





                            </tr>
                        </tbody>
                    </table>
                </div>

                <h3 style="text-align: center;">Almacenamiento en Bloques (Block Storage)</h3>
                <div class="custom-table">
                    <table class="table">
                        <thead>
                            <tr>

                                <th scope="col">Plan</th>
                                <th scope="col">Espacio</th>
                                <th scope="col">Seguridad</th>
                                <th scope="col">Rendimiento</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td scope="row">
                                    Básico
                                </td>

                                <td class="special">
                                    500 GB
                                </td>
                                <td class="special">
                                    Cifrado básico
                                </td>
                                <td class="special">
                                    SSD estándar
                                </td>

                            </tr>
                            <tr>


                                <td scope="row">
                                    Profesional
                                </td>

                                <td class="special">
                                    2 TB
                                </td>
                                <td class="special">
                                    Cifrado avanzado
                                </td>
                                <td class="special">
                                    SSD NVMe
                                </td>


                            </tr>
                            <tr>

                                <td scope="row">
                                    Empresarial
                                </td>

                                <td class="special">
                                    5 TB
                                </td>
                                <td class="special">
                                    Cifrado avanzado
                                </td>
                                <td class="special">
                                    SSD NVMe Alta Velocidad
                                </td>



                            </tr>
                            <tr colspan="3">

                                <td colspan="5" scope="row">
                                    Plan Personalizado (Contáctanos)
                                </td>





                            </tr>
                        </tbody>
                    </table>
                </div>
                <h3 style="text-align: center;">Almacenamiento de Archivos (File Storage)</h3>
                <div class="custom-table">
                    <table class="table">
                        <thead>
                            <tr>

                                <th scope="col">Plan</th>
                                <th scope="col">Espacio</th>
                                <th scope="col">Protocolos</th>
                                <th scope="col">Respaldo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td scope="row">
                                    Básico
                                </td>

                                <td class="special">
                                    1 TB
                                </td>
                                <td class="special">
                                    NFS, SMB, SFTP
                                </td>
                                <td class="special">
                                    Diario
                                </td>

                            </tr>
                            <tr>


                                <td scope="row">
                                    Profesional
                                </td>

                                <td class="special">
                                    5 TB
                                </td>
                                <td class="special">
                                    NFS, SMB, SFTP
                                </td>
                                <td class="special">
                                    Snapshots y backups
                                </td>


                            </tr>
                            <tr>

                                <td scope="row">
                                    Empresarial
                                </td>

                                <td class="special">
                                    10 TB
                                </td>
                                <td class="special">
                                    NFS, SMB, SFTP
                                </td>
                                <td class="special">
                                    Replicación en tiempo real
                                </td>



                            </tr>
                            <tr colspan="3">

                                <td colspan="5" scope="row">
                                    Plan Personalizado (Contáctanos)
                                </td>





                            </tr>
                        </tbody>
                    </table>
                </div>

                <h3 style="text-align: center;">Almacenamiento de Archivos Fríos (Cold Storage)</h3>
                <div class="custom-table">
                    <table class="table">
                        <thead>
                            <tr>

                                <th scope="col">Plan</th>
                                <th scope="col">Espacio</th>
                                <th scope="col">Seguridad</th>
                                <th scope="col">Tiempo de Recuperación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td scope="row">
                                    Básico
                                </td>

                                <td class="special">
                                    1 TB
                                </td>
                                <td class="special">
                                    Cifrado básico
                                </td>
                                <td class="special">
                                    24 horas
                                </td>

                            </tr>
                            <tr>


                                <td scope="row">
                                    Profesional
                                </td>

                                <td class="special">
                                    5 TB
                                </td>
                                <td class="special">
                                    Cifrado avanzado
                                </td>
                                <td class="special">
                                    12 horas
                                </td>


                            </tr>
                            <tr>

                                <td scope="row">
                                    Empresarial
                                </td>

                                <td class="special">
                                    10 TB
                                </td>
                                <td class="special">
                                    Cifrado avanzado
                                </td>
                                <td class="special">
                                    1 hora
                                </td>



                            </tr>
                            <tr colspan="3">

                                <td colspan="5" scope="row">
                                    Plan Personalizado (Contáctanos)
                                </td>





                            </tr>
                        </tbody>
                    </table>

                </div>


            </div>
        </div>
    </div>
</section>



<section class="domain-pricing-list-area pt-70">
    <div class="container">
        <div class="row">


            <div class="col-lg-12 col-md-12">
                <h2 class="custom-table-title">Comparativa de Almacenamiento en la Nube de enCloud vs. Otras Opciones:
                </h2>

                <div class="custom-table">
                    <table class="table">
                        <thead>
                            <tr>

                                <th scope="col">Característica</th>
                                <th scope="col">enCloud</th>
                                <th scope="col">AWS S3</th>
                                <th scope="col">Google Cloud Storage</th>
                                <th scope="col">Azure Blob Storage</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td scope="row">
                                    Costo por GB
                                </td>

                                <td class="special">
                                    Más accesible
                                </td>
                                <td class="special">
                                    Medio
                                </td>
                                <td class="special">
                                    Alto
                                </td>
                                <td class="special">
                                    Medio
                                </td>
                            </tr>
                            <tr>


                                <td scope="row">
                                    Soporte Español
                                </td>

                                <td class="special">
                                    ✅ Sí
                                </td>
                                <td class="special">
                                    ❌ No
                                </td>
                                <td class="special">
                                    ❌ No
                                </td>
                                <td class="special">
                                    ❌ No
                                </td>

                            </tr>
                            <tr>

                                <td scope="row">
                                    Ubicación de servidores
                                </td>

                                <td class="special">
                                    México
                                </td>
                                <td class="special">
                                    EE.UU. / Global
                                </td>
                                <td class="special">
                                    EE.UU. / Global
                                </td>
                                <td class="special">
                                    EE.UU. / Global
                                </td>


                            </tr>
                            <tr>

                                <td scope="row">
                                    Cumplimiento de normativas
                                </td>

                                <td class="special">
                                    ✅ Sí
                                </td>
                                <td class="special">
                                    ✅ Sí
                                </td>
                                <td class="special">
                                    ✅ Sí
                                </td>
                                <td class="special">
                                    ✅ Sí
                                </td>


                            </tr>

                            <tr>
                                <td scope="row">
                                    Latencia optimizada para México
                                </td>

                                <td class="special">
                                    ✅ Sí
                                </td>
                                <td class="special">
                                    ❌ No
                                </td>
                                <td class="special">
                                    ❌ No
                                </td>
                                <td class="special">
                                    ❌ No
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>
</section>



<app-vs-others></app-vs-others>

<app-contact-form [section]="section" [pt]="pt" [pb]="pb" [title]="title"></app-contact-form>

<app-clients [pt]="pt" [pb]="pb"></app-clients>